import React from 'react';
import Radium from 'radium';
import Modal from 'react-responsive-modal';

import {A} from 'views/AppElements';
import AppConstants from 'AppConstants';

import LoginForm from 'views/user/LoginForm';
import RegisterForm from 'views/user/RegisterForm';
import ForgotPassword from 'views/user/ForgotPassword';

import SocialMediaLogin from 'views/user/SocialMediaLogin';

import AppUtil from 'AppUtil';

const style = {
	box: {padding: "5px 25px 15px 25px", borderRadius: "5px", margin: "auto"},

	blurLink: {color: "#a28348"},

	floatLeft: {float: "left"},
	floatRight: {float: "right"},
	clearFix: {clear: "both"}
};

const TERMS_OF_USE =<div style={{fontSize: "72%", color: "#a28348", marginTop: "15px", textAlign:"left"}}>
					By logging into {AppConstants.WEBSITE}, you agree to the {AppConstants.APP_NAME} <A href="/terms-of-use-and-privacy-policy" target="_blank" style={{color: "gray"}}>Terms & Conditions</A> and <A href="/terms-of-use-and-privacy-policy" target="_blank" style={{color: "gray"}}>Privacy Policy</A>.
					</div>;

const LoginSignUpFooter = Radium((props) => {

	const leftComponent = props.left;
	const rightComponent = props.right;
	return <div>
			<div style={[{padding: "15px 0", fontSize: "13px", '@media (max-width: 768px)': {fontSize: '12px'}}]}>
				<span style={{float: "left"}}>{leftComponent}</span>
				<span style={{float: "right"}}>{rightComponent}</span>
			</div>

			<div style={{clear: "both"}}></div>
			{TERMS_OF_USE}
		</div>
});



class LoginSignUpBox extends React.Component {

	constructor(props) {
		super(props);
		
		this.LOGIN_FORM = AppConstants.SIGN_UP_FORMS.LOGIN_FORM;
		this.REGISTER_FORM = AppConstants.SIGN_UP_FORMS.REGISTER_FORM;
		this.FORGOT_PASSWORD = AppConstants.SIGN_UP_FORMS.FORGOT_PASSWORD;
		this.SOCIAL_LOGIN = AppConstants.SIGN_UP_FORMS.SOCIAL_LOGIN;

		//by default, we always show SOCIAL_LOGIN
		const selectedForm = this.props.selectedForm? this.props.selectedForm: this.SOCIAL_LOGIN;
		this.state = {openModal: this.props.openLoginModal, selectedForm: selectedForm};
		this.handleModalClose = this.handleModalClose.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const newState = {openModal: nextProps.openLoginModal};

		if(nextProps.selectedForm && this.props.selectedForm !== nextProps.selectedForm)
			newState["selectedForm"] = nextProps.selectedForm;

		this.setState(newState);
	}

	selectForm(form) {
		this.setState({selectedForm: form});
	}

	handleModalClose() {
		//reset to default social login form on modal close
		this.setState({openModal: false, selectedForm: this.SOCIAL_LOGIN});
	}

	getSocialMediaLogin() {
		const leftDiv = <A href="#" style={[style.blurLink]} 
								onClick={this.selectForm.bind(this, this.LOGIN_FORM)}>Log In</A>;

		const rightDiv = <A href="#" style={[style.blurLink]} 
								onClick={this.selectForm.bind(this, this.REGISTER_FORM)}>Sign Up</A>;

		return <div>
				<SocialMediaLogin />

				<LoginSignUpFooter left={leftDiv} right={rightDiv} />
			</div>
	}

	getLoginForm() {

		const leftDiv = <span>
						<A href="#" onClick={this.selectForm.bind(this, this.REGISTER_FORM)}>
						{"Don't have an account?"}
						</A>
					</span>;

		const rightDiv = <A href="#" style={[style.blurLink]} 
						onClick={this.selectForm.bind(this, this.SOCIAL_LOGIN)}>Login via Social Media</A>;

		const forgetPasswordLink = <A href="#" style={[style.blurLink, {fontSize: '13px'}]} 
									onClick={this.selectForm.bind(this, this.FORGOT_PASSWORD)}>Forgot Password?</A>;

		const formData = (this.props.formData && this.props.selectedForm === this.LOGIN_FORM)? this.props.formData: null;
		
		return <div>
				<LoginForm formData={formData} forgetPasswordLink={forgetPasswordLink} />

				<LoginSignUpFooter left={leftDiv} right={rightDiv} />
		</div>
	}

	getRegisterForm() {
		const leftDiv = <A href="#" onClick={this.selectForm.bind(this, this.LOGIN_FORM)}>Already have an account?</A>;
		const rightDiv = <A href="#" style={[style.blurLink]} 
						onClick={this.selectForm.bind(this, this.SOCIAL_LOGIN)}>Register via Social Media</A>;

		const formData = (this.props.formData && this.props.selectedForm === this.REGISTER_FORM)? this.props.formData: null;
		return <div>
				<RegisterForm formData={formData}/>

				<LoginSignUpFooter left={leftDiv} right={rightDiv} />
		</div>
	}

	getForgotPasswordForm() {
		return <div>
				<ForgotPassword />
				<A href="#" onClick={this.selectForm.bind(this, this.LOGIN_FORM)}>{'Go Back'}</A>
		</div>
	}



	render() {
		const selectedForm = this.state.selectedForm;

		let form = null;

		if (selectedForm === this.LOGIN_FORM) form = this.getLoginForm();
		else if (selectedForm === this.REGISTER_FORM) form = this.getRegisterForm();
		else if (selectedForm === this.FORGOT_PASSWORD) form = this.getForgotPasswordForm();
		else if (selectedForm === this.SOCIAL_LOGIN) form = this.getSocialMediaLogin();
		
		const logoImg = AppUtil.getAppLogo();
		return (
			<Modal closeOnOverlayClick={false} open={this.state.openModal} onClose={this.handleModalClose} little 
						 classNames={{ overlay: 'login-overlay', modal: 'login-modal' }}>
				<div style={[style.box]}>
					<div style={{textAlign: "center"}}>
						<img src={logoImg} style={{width: "60%"}} alt={AppConstants.APP_NAME} title={AppConstants.APP_NAME} />
						
						
					</div>
					

					{form}
				</div> 
			</Modal>
			
				
			);
		

	}
}

LoginSignUpBox = Radium(LoginSignUpBox);
export default LoginSignUpBox;


// WEBPACK FOOTER //
// ./src/views/user/LoginSignUpBox.js